import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { Card, CardHeader } from '@material-ui/core';
import ActionRecordVoiceOver from '@material-ui/icons/RecordVoiceOver';
import { Link } from 'react-router-dom';

import { Line } from 'react-chartjs-2';

const styles = {
  titleLink: { textDecoration: 'none', color: '#000' },
  card: { borderLeft: 'solid 4px #4caf50', flex: 1, marginRight: '1em', marginTop: '1em' },
  icon: { float: 'right', width: 64, height: 64, padding: 16, color: '#4caf50' },
};

const location = { pathname: 'topics' };

const TopicsStats = ({ items = { data: [], total: 0 }, classes }) => {
  const colors = [
    'rgb(54, 162, 235)',
    'rgb(75, 192, 192)',
    'rgb(255, 159, 64)',
    'rgb(153, 102, 255)',
    'rgb(255, 99, 132)',
    'rgb(255, 205, 86)',
  ];

  const data = {
    labels:
      items.data.length > 0
        ? items.data[0].interval.map(nt => {
            const d = new Date(nt.date);
            return d.getMonth() + 1 + '/' + d.getFullYear();
          })
        : [],
    datasets: items.data.map((i, ndx) => ({
      label: i.name,
      fill: false,
      backgroundColor: colors[ndx % (colors.length - 1)],
      borderColor: colors[ndx % (colors.length - 1)],
      data: i.interval.map(t => t.articles + t.comments + t.likes),
    })),
  };

  return (
    <Card className={classes.card}>
      <ActionRecordVoiceOver className={classes.icon} />
      <CardHeader
        title={
          <Link to={location} className={classes.titleLink}>
            Topics
          </Link>
        }
        subtitle="mentions last 180 days"
      />

      <Line data={data} />
    </Card>
  );
};

TopicsStats.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(TopicsStats);


// WEBPACK FOOTER //
// ./src/dashboard/TopicsStats.js